export interface CsvColumnDef<T> {
  header: string;
  value: (row: T) => string | number | null | undefined;
}

const escapeCsvField = (value: string): string => {
  if (
    value.includes(",") ||
    value.includes('"') ||
    value.includes("\n") ||
    value.includes("\r")
  ) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

export const buildCsv = <T>(rows: T[], columns: CsvColumnDef<T>[]): string => {
  const headerLine = columns.map((col) => escapeCsvField(col.header)).join(",");
  const dataLines = rows.map((row) =>
    columns
      .map((col) => {
        const value = col.value(row);
        return escapeCsvField(value == null ? "" : String(value));
      })
      .join(",")
  );
  return [headerLine, ...dataLines].join("\n");
};

export const downloadCsv = <T>({
  rows,
  columns,
  filename,
}: {
  rows: T[];
  columns: CsvColumnDef<T>[];
  filename: string;
}) => {
  const blob = new Blob([buildCsv(rows, columns)], {
    type: "text/csv;charset=utf-8;",
  });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};
